import React, { forwardRef, useId } from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

export const Input = forwardRef(
  (
    {
      label,
      hideLabel = false,
      hint,
      error,
      className,
      inputClassName,
      id,
      ...props
    },
    ref
  ) => {
    const autoId = useId()
    const inputId = id ?? autoId

    return (
      <div className={cx("ui-field", className)}>
        {label && (
          <label
            className={cx("ui-label", hideLabel && "ui-label--sr-only")}
            htmlFor={inputId}
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cx("ui-input", inputClassName)}
          {...props}
        />
        {hint && <p className="ui-hint">{hint}</p>}
        {error && <p className="ui-error">{error}</p>}
      </div>
    )
  }
)

Input.displayName = "Input"
